var _g, _rect, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRiLinkExpiredMainIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45Z",
    fill: "#F9A000",
    fillOpacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#F9A000",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26482_25060)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26482_25060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H65V65H25V25Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26482_25060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.806 41C52.926 42.258 53 43.584 53 45C53 45.5304 52.7892 46.0392 52.4142 46.4142C52.0392 46.7892 51.5304 47 51 47C50.4696 47 49.9608 46.7892 49.5858 46.4142C49.2108 46.0392 49 45.5304 49 45C49 43.574 48.922 42.244 48.79 41H41.184C40.906 43.6593 40.9034 46.3402 41.176 49H45C45.5304 49 46.0392 49.2108 46.4142 49.5858C46.7892 49.9608 47 50.4696 47 51C47 51.5304 46.7892 52.0392 46.4142 52.4142C46.0392 52.7892 45.5304 53 45 53H41.832C42.77 57.16 44.236 59.82 45.002 61C45.002 61 46.58 61.026 46.854 61.004C47.3822 60.9698 47.9026 61.1446 48.303 61.4906C48.7034 61.8368 48.9516 62.3264 48.994 62.854C49.0326 63.3828 48.8596 63.9052 48.513 64.3066C48.1664 64.7078 47.6748 64.9552 47.146 64.994C46.958 65.008 45 65 45 65C33.972 65 25 56.028 25 45C25 33.97 33.972 25 45 25C56.028 25 65 33.97 65 45C65 45.758 64.928 46.498 64.842 47.232C64.7626 47.744 64.4878 48.2052 64.0754 48.5188C63.663 48.8322 63.145 48.9738 62.6306 48.9134C62.116 48.853 61.6448 48.5956 61.3162 48.1952C60.9874 47.7948 60.8268 47.2824 60.868 46.766C60.938 46.184 61 45.6 61 45C61 43.616 60.804 42.28 60.474 41H52.806ZM44.976 29.072C44.204 30.284 42.776 32.934 41.848 37H48.122C47.19 32.934 45.752 30.284 44.976 29.072ZM29.526 49H37.164C37.048 47.742 36.974 46.42 36.974 45.008C36.9753 43.6697 37.0393 42.3323 37.166 41H29.526C29.194 42.28 29 43.616 29 45C29.005 46.3502 29.1817 47.6944 29.526 49ZM31.164 53C33.139 56.4074 36.2971 58.9704 40.038 60.202C38.9959 57.8986 38.2254 55.4816 37.742 53H31.164ZM37.746 37C38.348 33.998 39.216 31.594 40.046 29.794C36.3014 31.0246 33.14 33.5894 31.164 37H37.746ZM52.224 37H58.834C56.8498 33.5734 53.6696 31.0006 49.904 29.776C50.9588 32.0843 51.7376 34.5091 52.224 37Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4464 62.8908L50.3462 51.6702C49.9638 50.829 50.8292 49.9638 51.6704 50.346L62.8908 55.4464C63.6566 55.7944 63.6766 56.875 62.9242 57.2512L59.4404 58.993C59.2468 59.0898 59.09 59.2468 58.9932 59.4402L57.2512 62.9242C56.875 63.6766 55.7946 63.6566 55.4464 62.8908Z",
    fill: "#F9A000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26482_25060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(25 25)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRiLinkExpiredMainIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RI_link_expired_main_icon.df996a41474b04156463d0016fb1779f.svg";